import { useState, useEffect } from 'react';
import axios from 'axios';

import routes from 'app/routes';

export default function useChats() {
  const [chats, setChats] = useState(null);

  const updateCountUnreadMessage = () => {
    axios
      .get(routes.api.session_rooms.for_list)
      .then((response) => {
        const allChats = response.data.data;

        setChats((prev) => prev.map((chat) => {
          const newItem = allChats.find((item) => item.id === chat.id);

          return {
            ...chat,
            attributes: {
              ...chat.attributes,
              unread: newItem ? newItem.attributes.unread : chat.attributes.unread,
              student_archived_at: newItem
                ? newItem.attributes.student_archived_at
                : chat.attributes.student_archived_at,
            },
          };
        }));
      });
  };

  useEffect(() => {
    axios
      .get(routes.api.session_rooms.for_list)
      .then((response) => {
        const allChats = response.data.data;

        setChats(allChats);
      });
  }, []);

  return { chats, updateCountUnreadMessage };
}
